





































import Vue from "vue";
import Component from "vue-class-component";
import { IUserGridModel } from "../../models";
import { Inject } from "vue-property-decorator";
import { RestClient } from "@elite/restclient";
import { GridOptions } from "ag-grid-community";
import { AjaxDataSource, DefaultGridOptions } from "../../table";
import initializeTable from "../../table/InitializeTable";
import UserManagementEvents from "./UserManagementEvents";

@Component
export default class UserManagementGrid extends Vue {
    @Inject()
    restClient!: RestClient;

    gridOptions: GridOptions = new DefaultGridOptions();

    dataSource: AjaxDataSource<IUserGridModel> | null = null;

    mounted(): void {
        this.dataSource = new AjaxDataSource<IUserGridModel>(
            this.restClient,
            "/api/UserGrid"
        );

        initializeTable(
            this.gridOptions,
            this.dataSource,
            UserManagementEvents.gridRefreshEvent,
            this
        );
    }
}
